"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSlider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _pureReactCarousel = require("pure-react-carousel");

var _2 = require("../..");

var _utils = require("../../../utils");

var _hooks = require("../../../hooks");

var _icons = require("../../../icons");

var _imageSliderModule = _interopRequireDefault(require("./image-slider.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MEDIA_QUERIES = ["(min-width: ".concat(_utils.XS, "px)")];

var ImageSlider = function ImageSlider(_ref) {
  var slides = _ref.slides,
      images = _ref.images,
      captions = _ref.captions,
      isPlaying = _ref.isPlaying,
      interval = _ref.interval,
      dots = _ref.dots,
      arrows = _ref.arrows;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      lightboxImage = _useState2[0],
      setLightboxImage = _useState2[1];

  var isArrowRightKeyPressed = (0, _hooks.useKeyPress)("ArrowRight");
  var isArrowLeftKeyPressed = (0, _hooks.useKeyPress)("ArrowLeft");
  var prevImage = (0, _react.useMemo)(function () {
    if (lightboxImage === null || images.length === 1) {
      return null;
    }

    var index = images.indexOf(lightboxImage);

    if (index < 0) {
      return null;
    }

    var prevIndex = index - 1;

    if (prevIndex < 0) {
      return images[images.length - 1];
    }

    return images[prevIndex];
  }, [lightboxImage, images]);
  var nextImage = (0, _react.useMemo)(function () {
    if (lightboxImage === null || images.length === 1) {
      return null;
    }

    var index = images.indexOf(lightboxImage);

    if (index < 0) {
      return null;
    }

    var nextIndex = index + 1;

    if (nextIndex >= images.length) {
      return images[0];
    }

    return images[nextIndex];
  }, [lightboxImage, images]);
  var clickEnlargeHandler = (0, _react.useCallback)(function (image) {
    setLightboxImage(image);
  }, []);
  var clickPrevHandler = (0, _react.useCallback)(function () {
    setLightboxImage(prevImage);
  }, [prevImage]);
  var clickNextHandler = (0, _react.useCallback)(function () {
    setLightboxImage(nextImage);
  }, [nextImage]);
  var clickCloseHandler = (0, _react.useCallback)(function () {
    setLightboxImage(null);
  }, []);
  var setImageDebounced = (0, _react.useCallback)((0, _utils.debounce)(function (image) {
    setLightboxImage(image);
  }), []);
  (0, _react.useEffect)(function () {
    if (isArrowLeftKeyPressed) {
      setImageDebounced(prevImage);
    }
  }, [isArrowLeftKeyPressed, setImageDebounced, prevImage]);
  (0, _react.useEffect)(function () {
    if (isArrowRightKeyPressed) {
      setImageDebounced(nextImage);
    }
  }, [isArrowRightKeyPressed, setImageDebounced, nextImage]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, slides.length > 1 ? /*#__PURE__*/_react.default.createElement(_pureReactCarousel.CarouselProvider, {
    interval: interval,
    isPlaying: isPlaying,
    isIntrinsicHeight: true,
    lockOnWindowScroll: true,
    totalSlides: slides.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.slider
  }, /*#__PURE__*/_react.default.createElement(_pureReactCarousel.Slider, null, slides.map(function (image, index) {
    return /*#__PURE__*/_react.default.createElement(_pureReactCarousel.Slide, {
      key: index,
      index: index
    }, /*#__PURE__*/_react.default.createElement(Image, {
      slide: image,
      image: images[index],
      caption: captions[index],
      onEnlarge: clickEnlargeHandler
    }));
  })), arrows && /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.arrows
  }, /*#__PURE__*/_react.default.createElement(_pureReactCarousel.ButtonBack, {
    className: _imageSliderModule.default.prev
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowLeftIcon, {
    className: _imageSliderModule.default.arrow
  })), /*#__PURE__*/_react.default.createElement(_pureReactCarousel.ButtonNext, {
    className: _imageSliderModule.default.next
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowRightIcon, {
    className: _imageSliderModule.default.arrow
  }))), dots && /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.dots
  }, slides.map(function (_, index) {
    return /*#__PURE__*/_react.default.createElement(_pureReactCarousel.Dot, {
      key: index,
      slide: index,
      className: _imageSliderModule.default.dot
    });
  })))) : /*#__PURE__*/_react.default.createElement(Image, {
    slide: slides[0],
    image: images[0],
    caption: captions[0],
    onEnlarge: clickEnlargeHandler
  }), lightboxImage && /*#__PURE__*/_react.default.createElement(_2.Modal, {
    size: "auto",
    showCloseButton: false,
    onClose: clickCloseHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.lightbox
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.image
  }, /*#__PURE__*/_react.default.createElement(_gatsbyImage.default, {
    className: _imageSliderModule.default.img,
    fluid: lightboxImage.childImageSharp.fluid,
    style: {
      width: "".concat(lightboxImage.childImageSharp.fluid.presentationWidth, "px")
    }
  })), prevImage && /*#__PURE__*/_react.default.createElement("button", {
    onClick: clickPrevHandler,
    className: _imageSliderModule.default.prev
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowLeftIcon, {
    className: _imageSliderModule.default.arrow
  })), nextImage && /*#__PURE__*/_react.default.createElement("button", {
    onClick: clickNextHandler,
    className: _imageSliderModule.default.next
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowRightIcon, {
    className: _imageSliderModule.default.arrow
  })), /*#__PURE__*/_react.default.createElement("button", {
    onClick: clickCloseHandler,
    className: _imageSliderModule.default.escape
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseIcon, {
    className: _imageSliderModule.default.close
  })))));
};

exports.ImageSlider = ImageSlider;
ImageSlider.defaultProps = {
  dots: true,
  isPlaying: false,
  arrows: true,
  interval: 5000,
  images: [],
  captions: []
};
ImageSlider.propTypes = {
  dots: _propTypes.default.bool,
  arrows: _propTypes.default.bool,
  isPlaying: _propTypes.default.bool,
  interval: _propTypes.default.number,
  slides: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    childImageSharp: _propTypes.default.shape({
      fluid: _propTypes.default.object.isRequired
    }).isRequired
  }).isRequired).isRequired,
  images: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    childImageSharp: _propTypes.default.shape({
      fluid: _propTypes.default.object.isRequired
    }).isRequired
  }).isRequired),
  captions: _propTypes.default.arrayOf(_propTypes.default.string.isRequired)
};

var Image = function Image(_ref2) {
  var slide = _ref2.slide,
      image = _ref2.image,
      caption = _ref2.caption,
      onEnlarge = _ref2.onEnlarge;

  var _useMatchMedia = (0, _hooks.useMatchMedia)(MEDIA_QUERIES),
      _useMatchMedia2 = _slicedToArray(_useMatchMedia, 1),
      isXS = _useMatchMedia2[0];

  var fluid = (0, _utils.getProperty)(slide, "childImageSharp.fluid");
  var clickEnlargeHandler = (0, _react.useCallback)(function () {
    onEnlarge(image);
  }, [onEnlarge, image]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.container
  }, /*#__PURE__*/_react.default.createElement(_gatsbyImage.default, {
    fluid: fluid
  }), caption && /*#__PURE__*/_react.default.createElement("div", {
    className: _imageSliderModule.default.caption
  }, /*#__PURE__*/_react.default.createElement(_2.Text, {
    color: "white",
    weight: "bold",
    transform: "uppercase",
    size: isXS ? "xl" : "md"
  }, caption)), image && /*#__PURE__*/_react.default.createElement("button", {
    onClick: clickEnlargeHandler,
    className: _imageSliderModule.default.enlarge
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusIcon, {
    className: _imageSliderModule.default.plus
  })));
};

Image.defaultProps = {
  onEnlarge: function onEnlarge() {}
};
Image.propTypes = {
  slide: _propTypes.default.object.isRequired,
  image: _propTypes.default.object,
  caption: _propTypes.default.string,
  onEnlarge: _propTypes.default.func
};